// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"1fc0b484","292":"ab7b131c","492":"1c6de1d9","625":"5464b53f","647":"5ce7684b","742":"6608f832"}[chunkId] + ".chunk.js";
};